module.exports = __webpack_public_path__ + "static/media/7. Ir y venir, Óleo sobre policarbonato, 43 x 38 cm, 2014 copy.16fdcdee.png";